import React from "react";

const BookMarkButton = () => {
  const url = "https://app.box.com/s/8eaamnl91kt2avbsyfuzh01rgrzn04ti";

  const openPreview = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ actionType: "MODAL", uri: url }));
    } else {
      window.open(url, "_blank");
    }
  };

  return (
    <button style={{ backgroundColor: "inherit", border: "none", marginRight: "16px", padding: 0 }} onClick={openPreview}>
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24" fill="none">
        <g clip-path="url(#clip0_2378_21413)">
          <path
            d="M0 3C0 1.34531 1.34531 0 3 0H18.75C19.9922 0 21 1.00781 21 2.25V17.25C21 18.2297 20.3719 19.0641 19.5 19.3734V22.5H20.25C20.6625 22.5 21 22.8375 21 23.25C21 23.6625 20.6625 24 20.25 24H3C1.34531 24 0 22.6547 0 21V3ZM3 19.5C2.17031 19.5 1.5 20.1703 1.5 21C1.5 21.8297 2.17031 22.5 3 22.5H18V19.5H3ZM1.5 18.4031C1.94062 18.15 2.45156 18 3 18H4.5V1.5H3C2.17031 1.5 1.5 2.17031 1.5 3V18.4031ZM6 1.5V18H18.75C19.1625 18 19.5 17.6625 19.5 17.25V2.25C19.5 1.8375 19.1625 1.5 18.75 1.5H6Z"
            fill="#00263E"
          />
        </g>
        <defs>
          <clipPath id="clip0_2378_21413">
            <rect width="21" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </button>
  );
};

export default BookMarkButton;
